import { Action } from "redux";

import { OrganizationKeyName } from "../../../model/Organization";

export const GET_ORGANIZATION = "ORGANIZATION:GET_ORGANIZATION";

export interface GetOrganizationAction extends Action {
  type: typeof GET_ORGANIZATION;
  organization: OrganizationKeyName;
}

export const getOrganizationAction = (
  organization: OrganizationKeyName
): GetOrganizationAction => ({
  type: GET_ORGANIZATION,
  organization,
});
